import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Button, Grid } from "@mui/material";
import { fetchWebsiteSettings, selectWebsiteSettings } from '../../redux/slices/settings/WebsiteSettingsSlice';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumb from "../../components/services/Breadcrumb/Breadcrumb";
import FeatureCard from "../../components/services/FeatureCard/FeatureCard";
import HeaderSection from "../../components/services/HeaderSection/HeaderSection";
import './service.scss';

import Gallery from "../../components/services/Gallery/Gallery";
import NotFound from "../../components/NotFoundService/NotFoundService";
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import FeatureGrid from "../../components/services/FeatureGrid/FeatureGrid";
import Loading from "../../components/UI/Loading/Loading";
const ServicePage = () => {
    const { translations, direction, language } = useLanguage();
    const t = translations;
    const { id } = useParams(); // Fetch service ID from the URL
    const services = useSelector(selectWebsiteSettings);
    const loading = useSelector((state) => state.websiteSettings.loading); 

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchWebsiteSettings(5)); // Fetch services when the component mounts
    }, [dispatch]);
    if (loading) return <Loading />;

    const service = services?.find((s) => s.Id === parseInt(id)); // Match service by ID

    // Handle button click and pass both service id and title
    const handleButtonClick = (serviceId, serviceTitle) => {
        navigate(`/request-price?serviceId=${serviceId}&serviceTitle=${encodeURIComponent(serviceTitle)}`);
    };
    if (!service) {
        return <NotFound message="الخدمة غير موجودة" />;
    }

    return (
        <Box sx={{ backgroundColor: "#f8fafb", minHeight: "80vh" }}>
            {/* Breadcrumb Section */}
            <Breadcrumb items={[t.Services, language === 'Arabic' ? service?.ValueAr : service?.Value]} direction={direction} />

            <Box sx={{ direction: "ltr !important" }}>
                {/* Header Section */}
                <HeaderSection
                    mainImage={service?.FilePath}
                    title={language === 'Arabic' ? service?.ValueAr : service?.Value}
                    description={language === 'Arabic' ? service?.DescriptionAr : service?.DescriptionEn}
                    buttonLabel={t.buttonText}
                    onButtonClick={() => handleButtonClick(id, language === 'Arabic' ? service?.ValueAr : service?.Value)}
                    t={t}
                    direction={direction}
                />

                {/* Features Section */}
                <FeatureGrid language={language} t={t} />
                <Box sx={{ mt: 8, ml: 4, mr: 4, mb: 8 }}>
                    <Gallery  data-aos="zoom-in" t={t} />
                </Box>
            </Box>
        </Box>
    );
};

export default ServicePage;
